import { validateEmail } from '@/functions';
import React, { useState } from 'react';
import { Drawer, Radio, RadioGroup, Input, InputGroup, useToaster, Message } from 'rsuite';
import { Daction, divStyle, styles } from '@/common';

export default function GenerateAccess({ open, close, typeCode, setEmailList, emailList }) {
  const [value, setValue] = React.useState('Not-allow');
  const [newEmail, setNewEmail] = useState('');
  const toaster = useToaster();

  const handleAction = actionType => {
    if (newEmail.trim() != '') {
      const isAllow = actionType === 'Allow';
      const index = emailList.findIndex(item => item.emailid.trim() === newEmail.trim());
      if (!validateEmail(newEmail.trim())) {
        toaster.push(
          <Message showIcon type="error">
            Please enter a valid email address!
          </Message>,
          { placement: 'topEnd' }
        );
      } else if (isAllow) {
        setEmailList(prevList => {
          const update = [...prevList];
          if (index !== -1) {
            update[index].emailsts = true;
            update[index].typecode = typeCode;
          } else {
            update.push({ emailid: newEmail.trim(), typecode: typeCode, emailsts: true });
          }
          return update;
        });
        setNewEmail('');
      } else if (index !== -1) {
        setEmailList(prev => {
          const update = [...prev];
          update[index].emailsts = false;
          update[index].typecode = typeCode;
          return update;
        });
        setNewEmail('');
      } else {
        toaster.push(
          <Message showIcon type="error">
            Email not found in the list.
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } else {
      toaster.push(
        <Message showIcon type="error">
          'Please enter an email address.
        </Message>,
        { placement: 'topEnd' }
      );
    }
  };

  return (
    <Drawer open={open} onClose={close} size="xs" backdrop="static">
      <Drawer.Header>
        <Drawer.Title>
          <h5>Restrict Access</h5>
        </Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <Drawer.Actions style={Daction}>
          <div>
            <RadioGroup name="radioList" inline value={value} onChange={setValue}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '10px',
                  flexDirection: 'column'
                }}
              >
                <div style={divStyle}>
                  <Radio value="Allow">
                    <h6>Allow Specific email id's</h6>
                    Allow specified emails to access your catalogue while blocking everyone else.
                  </Radio>
                </div>
                <div style={divStyle}>
                  <Radio value="Not-allow">
                    <h6>Block Specific email's</h6>
                    List which visitors should be blocked from accessing your catalogue.
                  </Radio>
                </div>
              </div>
            </RadioGroup>
          </div>

          <div style={{ marginTop: '20px' }}>
            <label htmlFor="">Email Id</label>
            <InputGroup inside style={styles}>
              <Input
                type="email"
                value={newEmail}
                onChange={value => setNewEmail(value.trim())}
                style={{ width: '100% !important' }}
              />
              <InputGroup.Button onClick={() => handleAction(value)}>
                {value == 'Allow' ? 'Allow' : 'Block'}
              </InputGroup.Button>
            </InputGroup>
          </div>
          {emailList.length &&
            emailList.map(item => {
              return (
                <InputGroup inside style={styles} key={item.emailid}>
                  <Input
                    disabled
                    value={item.emailid}
                    style={{ color: !item.emailsts ? 'red' : '' }}
                  />
                </InputGroup>
              );
            })}
        </Drawer.Actions>
      </Drawer.Body>
    </Drawer>
  );
}
